import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";

const token = localStorage.getItem('authToken');

class EditPackages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            amount: "",
            link: "",
            areaInput: "",
            currentImageUrl: null,
            submissionStatus: null,
            submeet: false,
            errors: [],
            startDate: "",
            endDate: "",
        };
    }

    async componentDidMount() {
        const { match } = this.props;
        if (match && match.params && match.params.id) {
            const { id } = match.params;
            this.setState({ id });
            await this.userData(id);
        } else {
            console.error("No match params found.");
        }
    }

    userData = async (id) => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/packages/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
    
            if (response) {
                const { title, description, amount, link, packageType, startDate, endDate } = response.data.data;
                this.setState({
                    title: title,
                    areaInput: description,
                    amount: amount,
                    link: link,
                    packageType: packageType || "",
                    startDate: startDate ? new Date(startDate).toISOString().split('T')[0] : "",
                    endDate: endDate ? new Date(endDate).toISOString().split('T')[0] : ""
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    handleChange = (e) => {
        const files = Array.from(e.target.files);
        const errors = [];

        files.forEach((file) => {
            if (file.size > this.state.maxSize) {
                errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
            } else {
                this.setState({
                    textInput: file,
                    currentImageUrl: URL.createObjectURL(file),
                });
            }
        });

        this.setState({ errors });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
    
        this.setState({ submeet: true });
    
        const { title, areaInput, amount, link, packageType, startDate, endDate } = this.state;
        const { id } = this.props.match.params;
    
        const data = {
            title,
            amount,
            description: areaInput,
            link,
            packageType,
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };
        

        console.log('Submitted Data:', data);
    
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            };
    
            const response = await axios.put(`https://samaj.aasmo.in/api/admin/packages/${id}`, data, config);
    
            if (response.status === 200) {
                this.setState({ submissionStatus: 'success', submeet: false });
                // Optionally redirect
                setTimeout(() => {
                    this.props.history.push("/packageslist");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    render() {
        const { amount, link, showModalReject, title, currentImageUrl, areaInput, submissionStatus } = this.state;
        const isTitleValid = title.trim().length > 0;
        const isLinkValid = link?.trim().length > 0;

        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Edit Packages</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    className={`form-control ${!isTitleValid && this.state.submeet && "parsley-error"}`}
                                    value={title}
                                    name="title"
                                    required
                                    type="text"
                                    onChange={(e) => this.setState({ title: e.target.value })}
                                />
                                {!isTitleValid && this.state.submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Amount</label>
                                <input
                                    className={`form-control ${this.state.submeet && !amount ? "parsley-error" : ""}`}
                                    value={amount}
                                    name="amount"
                                    required
                                    type="number"
                                    onChange={(e) => this.setState({ amount: e.target.value })}
                                />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && this.state.submeet && "parsley-error"}`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required
                                    rows="5"
                                    onChange={(e) => this.setState({ areaInput: e.target.value })}
                                ></textarea>
                                {areaInput === "" && this.state.submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Link</label>
                                <input
                                    className={`form-control ${!isLinkValid && this.state.submeet && "parsley-error"}`}
                                    value={link}
                                    name="link"
                                    required
                                    type="text"
                                    onChange={(e) => this.setState({ link: e.target.value })}
                                />
                                {!isLinkValid && this.state.submeet && (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">This value is required.</li>
                                    </ul>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Package Type</label>
                                <input
                                    className="form-control"
                                    value={this.state.packageType}
                                    name="packageType"
                                    type="text"
                                    onChange={(e) => this.setState({ packageType: e.target.value })}
                                />
                            </div>

                            <div className="form-group">
                                <label>Start Date</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={this.state.startDate}
                                    name="startDate"
                                    onChange={(e) => this.setState({ startDate: e.target.value })}
                                />
                            </div>

                            <div className="form-group">
                                <label>End Date</label>
                                <input
                                    className="form-control"
                                    type="date"
                                    value={this.state.endDate}
                                    name="endDate"
                                    onChange={(e) => this.setState({ endDate: e.target.value })}
                                />
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
                <ConfirmApprovedModel
                    show={this.state.showModal}
                    handleClose={() => this.setState({ showModal: false })}
                    handleConfirm={() => this.handleUpdate(this.state.selectedCategoryId)}
                />
                <ConfirmRejectModel
                    show={showModalReject}
                    handleClose={() => this.setState({ showModalReject: false })}
                    handleConfirm={() => this.handleUpdateReject(this.state.selectedCategoryIdReject)}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditPackages));
